import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useLocationOptional, useNavigateOptional } from "../../../utils/hooks";
import { Clickable } from "../../button/Clickable";
import { Icon, iconList } from "../../graphic/Icon/Icon";
import styles from "./TabPane.scss";

export const TabPane = ({ label, icon, iconColor, link, tabKey, onChange, onClick, activeKey, exact }) => {
    const location = useLocationOptional();
    const navigate = useNavigateOptional();

    /**
     * Handle table click
     */
    const handleTabClick = () => {
        if (link) {
            navigate(link);
        } else if (onClick) {
            onClick();
        } else {
            onChange && onChange(tabKey);
        }
    };

    let isActive = tabKey === activeKey;
    if (link) {
        const linkPathname = link.split("?")[0];
        isActive = exact ? location.pathname === linkPathname : location.pathname.startsWith(linkPathname);
    }

    return (
        <Clickable
            className={classNames(styles.tab, {
                [styles.active]: isActive
            })}
            onClick={handleTabClick}
        >
            {/* Icon */}
            {icon ? <Icon name={icon} color={iconColor} className={styles.icon} /> : null}

            {/* Label */}
            {label ? <span className={styles.label}>{label}</span> : null}
        </Clickable>
    );
};

TabPane.propTypes = {
    /**
     * Tab label
     */
    label: PropTypes.any,
    /**
     * Tab icon
     */
    icon: PropTypes.oneOf(iconList),
    /**
     * Icon color
     */
    iconColor: PropTypes.oneOf(["primary", "contrast", "success", "warning", "error", "info"]),
    /**
     * Key that indicates active pane
     */
    tabKey: PropTypes.any,
    /**
     * Link path that activates tab. (Use instead of tabKey)
     */
    link: PropTypes.string,
    /**
     * If exact is true and link is used, the TabPane is active if the link matches the url pathname exactly (without search params).
     */
    exact: PropTypes.bool,
    /**
     * Content of tab pane
     */
    children: PropTypes.element
};
